import { useTheme } from '../../../../../theme/theme';

export const useAssetBucketingColors = (): string[][] => {
  const {
    colors: { green, teal, yellow, indigo },
  } = useTheme();

  return [
    [green[400], green[600], green[300], green[500], green[800]],
    [teal[400], teal[600], teal[300], teal[500], teal[800]],
    [yellow[400], yellow[600], yellow[300], yellow[500], yellow[800]],
    [indigo[700], indigo[500], indigo[300], indigo[800], indigo[400]],
  ];
};
